
class CapSubmitOneTimeRide {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'submit_one_time_ride'
}

function create(config) {
  return new CapSubmitOneTimeRide(config)
}

export default {
  key,
  create,
}
